<template>
  <v-row>
    <v-window
      v-model="window"
      :vertical="vertical"
      :show-arrows="showArrows"
      :reverse="reverse"
      show-arrows-on-hover
      dark
      continuous
      :style="windowStyle"
    >
      <template v-for="adItem in adItems" >
        <v-window-item :key="adItem.id">
          <v-row >
            <template v-for="(content, index) in adItem.adItemContents">
              <v-col :key="index" >
                <v-tooltip left :disabled="!content.tooltip">
                  <template v-slot:activator="{ on: tooltip }">
                    <v-card
                      color="transparent"
                      flat
                      :height="GetDimension(content.frontColumn,  IsVertical(adItem.adItemContents)).height"
                      :width="GetDimension(content.frontColumn,   IsVertical(adItem.adItemContents)).width"
                      v-on="tooltip"
                      @click="ResolveClick(content)"
                    >
                    <v-img
                      wigth="100%"
                      height="100%"
                      :src="content.sourceLink"
                      contain
                    ></v-img>
                    </v-card>
                  </template>
                  <span>{{content.tooltip}}</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-row>
        </v-window-item>
      </template>
    </v-window>

    <v-dialog v-model="dialog" max-width="1000px" max-height="600px">
      <v-card>
        <v-card-title>
          <span class="headline"></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <iframe
                v-show="video.show"
                :src="video.src"
                frameborder="0"
                allowfullscreen
                width="600px"
                height="600px"
              ></iframe>
              <v-img 
                :key="image.src"
                v-show="image.show"
                :src="image.src"
                @click="GoodSearch()"></v-img>
              <iframe
                width="auto"
                height="auto"
                frameborder="0"
                v-show="presentation.show"
                :src="presentation.src"
              ></iframe>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { resolvePrimaryOpen } from "../../utils/adOpenResolver";

export default {
  props: {
    adLocation: Number,
    goodsId: Number,
    maxWidth: {
      type: String,
      default: "825px",
    },
  },
  data: () => ({
    dialog: false,
    window: 0,
    vertical: true,
    reverse: true,
    autorun: true,
    video: { show: false, src: "" },
    image: { show: false, src: "" },
    presentation: { show: false, src: "" },
    openType: null
  }),

  methods: {
    ResolveClick(content) {
      let openType = resolvePrimaryOpen(content.adItemContentOpens);
      if (openType == null) return;

      this.AdItemContentOpen(openType);
    },
    GoodSearch() {
      if (this.openType !== null) {
        let adItemContent = this.adItems
          .flatMap(item => item.adItemContents)
          .find(ad => ad.id === this.openType.adItemContentId);

        let openType = adItemContent.adItemContentOpens.find(o => o.adItemContentOpenTypeId == 0);

        if (openType != null) {
          let Search = {
            fullName: openType.sourceLink,
            beInThePrices: false,
            advanced: {
              INN: "",
              brand: "",
              ATC: "",
              producer: "",
              show: false,
            },
          };
          this.$store.commit("SET_GOODS_SEARCH", Search);
          if(this.$route.name != 'order')
              this.$router.push({path: '/order'})
        }

        this.dialog = false;
      }
    },
    AdItemContentOpen(openType) {
      this.presentation.src = this.video.src = this.image.src = "";
      this.presentation.show = this.video.show = this.image.show = false;
      this.openType = openType;

      if (openType.adItemContentOpenType.id == 0) {
        let Search = {
          fullName: openType.sourceLink,
          beInThePrices: false,
          advanced: {
            INN: "",
            brand: "",
            ATC: "",
            producer: "",
            show: false,
          },
        };
        this.$store.commit("SET_GOODS_SEARCH", Search);
        if(this.$route.name != 'order')
            this.$router.push({path: '/order'})
      }

      if (openType.adItemContentOpenType.id == 1) {
        this.presentation.src =
          "https://docs.google.com/viewer?url=" +
          openType.sourceLink +
          "&embedded=true";
        this.presentation.show = true;
        this.dialog = true;
      }
      if (openType.adItemContentOpenType.id == 2) {
        this.video.src = openType.sourceLink;
        this.video.show = true;
        this.dialog = true;
      }
      if (openType.adItemContentOpenType.id == 3) {
        this.image.src = openType.sourceLink;
        this.image.show = true;
        this.dialog = true;
      }
      if (openType.adItemContentOpenType.id == 4) {
        window.open(openType.sourceLink, "_blank");
      }

      let payload = {
        adItemContentId: openType.adItemContentId,
        adItemContentOpenTypeId: openType.adItemContentOpenTypeId,
      };

      this.$store
      .dispatch("AD_CLICK", payload)
      .then(() => {
      })
      .catch((error) => {
        window.console.log(error);
      });
    },
    GetDimension(col, isVertical) {
      var dimension = this.$store.getters.AD_ITEM_CONTENT_DIMENSIONS(
        this.adLocation,
        col,
        isVertical
      );
      return dimension;
    },
    IsVertical(contents) {
      var result =
        contents
          .map((x) => x.frontColumn)
          .reduce(function (previousValue, currentValue) {
            return previousValue + currentValue;
          }) == 12;

      return result;
    },
   
  },
  mounted() {},
  computed: {
    ad: {
      get: function () {
        var result = this.$store.getters.ADS?.find(
          (x) => x.id == this.adLocation
        );
        return result;
      },
    },
    adItems: {
      get: function () {
        let result = this.ad?.adItems;

        if (this.goodsId != null){
          result = this.ad?.adItems?.filter((x) => x.goodsId == this.goodsId);
        }

        return result;
      },
    },
    showArrows: {
      get: function () {
        return this.adItems != null && this.adItems.length > 1;
      },
    },
    windowStyle: {
      get: function () {
        return { maxWidth: this.maxWidth };
      },
    },
  },
  created() {
    this.autorunInterval = setInterval(() => {
      if (!this.autorun) return;
      let count = this.adItems != null ? this.adItems.length : 0;
      if (count === 0) return;
      if (++this.window >= count) this.window = 0;
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.autorunInterval);
  },
};
</script>